import { Input } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useCustomerForm } from '../../../../contexts/customerFormContext'
import { AddressInputFieldProps } from '../../types/addressInputFieldProps'

type AddressPoboxProps = AddressInputFieldProps

export const AddressPobox = ({ isDisabled = false }: AddressPoboxProps): ReactElement => {
  const { t } = useTranslation()
  const { customerForm } = useCustomerForm()
  const { FormItem } = customerForm

  return (
    <FormItem
      label={t('customer_modal.form.address.pobox.label')}
      name="address.pobox"
      render={({ field }) => <Input {...field} disabled={isDisabled} size="sm" />}
    />
  )
}
